import { useApiQuery } from '@/hooks/useApiQuery';
import { apiPost, operationsClient } from '@/lib/api/client';
import { customFieldEndpoints } from '@/lib/api/endpoints';
import { customFieldKeys } from '@/lib/queryKeys';
import type {
  CustomFieldEntityType,
  CustomFieldFilterResponse,
  FilterCustomFieldsDto,
} from '@/types/custom-fields';

export function useCustomFieldFilterIds(
  entityType: CustomFieldEntityType,
  filter: FilterCustomFieldsDto | null,
) {
  return useApiQuery<CustomFieldFilterResponse>({
    queryKey: customFieldKeys.filter(entityType, filter),
    queryFn: () =>
      apiPost<CustomFieldFilterResponse, FilterCustomFieldsDto>(
        operationsClient,
        customFieldEndpoints.filter(),
        filter!,
      ),
    enabled: !!filter,
  });
}
